import React, {useEffect, useState, useImperativeHandle, useMemo} from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';

import { Form } from '@whalecloud/fdx';
import { getExchangeOfferFormItems } from './utils';
import get from "lodash/get";
import isEmpty from 'lodash/isEmpty';

import { renderFormItems } from '@/utils';


const AddressAttributes = props => {
  const BSNL_FTTH_EXCH = 'BSNL_FTTH_EXCH';
  const BSNL_FTTH_STD = 'BSNL_FTTH_STD';
  const {
    form, addressId, refInstance, offerAccessType, planDetail, subsDetail, exchangeId, stdCode,
    saveData, qryExchangeListByAddr, qryStdCodeListByExch, disabled,
  } = props;

  const { getFieldDecorator, setFieldsValue } = form;
  const [exchangeCodeList, setExchangeCodeList] = useState([]); // exchange列表
  const [stdCodeList, setStdCodeList] = useState([]); // stdCode列表
  const [initialEnd, setInitialEnd] = useState(false);

  useImperativeHandle(refInstance, () => ({
    getAddressAttrbutes: async () => {
      const { validateFields } = form;
      const subsAttrList = [];
      await validateFields().then(async exchangedInfo => {
        Object.keys({ ...exchangedInfo }).forEach(key => {
          if (exchangedInfo[key] && !key.includes('empty')) {
            let exchangedInfoValue = exchangedInfo[key];
            if (key === BSNL_FTTH_EXCH && !isEmpty(exchangeCodeList)) {
              exchangedInfoValue = get(exchangeCodeList.find(it => it.exchangeId === exchangeId), 'exchangeCode');
            }
            subsAttrList.push({
              attrCode: key,
              value: exchangedInfoValue,
              attrValue: exchangedInfoValue,
            });
          }
        });
      });
      return subsAttrList;
    },
  }));

  useEffect(() => {
    if (!isEmpty(planDetail)) {
      init();
    }
  }, [planDetail]);

  const init = async () => {
    // if (!offerAccessType) {
    const attrList = get(planDetail, 'subsPlanDto.attrDtoList') || [];
    const accessTypeArrObj = attrList.find(it => it.attrCode === 'EXP_ACCESS_TYPE') || {};
    await saveData({ offerAccessType: accessTypeArrObj.defaultValue });
    // }
  };

  useEffect(() => {
    async function initial() {
      // 如果是光网，需要根据地址查询exchangeCode
      if (checkAccessType() && addressId) {
        const payload = { addressId };
        await qryExchangeListByAddr(payload).then(result => {
          if (result) {
            const exchangeList = result.exchangeDtoList || [];
            setExchangeCodeList(exchangeList);
            if (!isEmpty(exchangeList)) {
              const { subsAttrDtoList = [] } = subsDetail;
              // 订户属性保存的是exchangeCode
              const bsnlFtthExch = get(subsAttrDtoList.find(element => element.attrCode === BSNL_FTTH_EXCH), 'value');
              // 如果已有订户属性
              if (bsnlFtthExch) {
                const bsnlFtthExchId = get(exchangeList.find(it => it.exchangeCode === bsnlFtthExch), 'exchangeId');
                if (bsnlFtthExchId) {
                  saveData({ exchangeId: bsnlFtthExchId });
                  const bsnlFtthStd = get(subsAttrDtoList.find(element => element.attrCode === BSNL_FTTH_STD), 'value');
                  if (bsnlFtthStd) {
                    saveData({ stdCode: bsnlFtthStd });
                  }
                }
              } else if (!exchangeId && result.hasDefaultExchange) {
                // 如果没有订户属性，且有默认值，默认选中第一个
                saveData({ exchangeId: get(exchangeList[0], 'exchangeId') });
              }
            }
          } else {
            setExchangeCodeList([]);
          }
        });
      }
      else {
        setExchangeCodeList([]);
      }
      setInitialEnd(true);
    }
    initial();
  }, [offerAccessType]);

  useEffect(() => {
    async function initial() {
      // 如果exchange选过了，需要根据exchangeId查询StdCode
      if (exchangeId) {
        const payload = { exchangeId };
        await qryStdCodeListByExch(payload).then(result => {
          if (result) {
            setStdCodeList(result.stdCodeDtoList || []);
          } else {
            setStdCodeList([]);
          }
        });
      }
      else {
        setStdCodeList([]);
      }
      if (!disabled) {
        setFieldsValue({'BSNL_FTTH_STD': null});
        saveData({stdCode: null});
      }
    }
    initial();
  }, [exchangeId]);

  const checkAccessType = () => {
    // 如果是光网或者air fiber，需要根据地址查询exchangeCode
    if (offerAccessType === 'FTTH' || offerAccessType === 'AIRFIBER') {
      return true;
    }
    return false;
  };

  const handleExchangeChange = value => {
    saveData({exchangeId: value});
  };

  const handleStdCodeChange = value => {
    saveData({stdCode: value});
  };

  const exchangeOfferFormItems = useMemo(() => getExchangeOfferFormItems({
    exchangeCodeList,
    stdCodeList,
    handleExchangeChange,
    handleStdCodeChange,
    exchangeId,
    stdCode,
    disabled
  }), [exchangeCodeList, stdCodeList, exchangeId, stdCode]);

  const renderAddressAttrFormItem = () => {
    return (
      <div className="blockWrap">
        <h3 className="blockTitle">{i18n('ADDRESS_ATTRIBUTES')}</h3>
        <div className="formItemBox">{renderFormItems(exchangeOfferFormItems, getFieldDecorator)}</div>
      </div>
    );
  };

  if (checkAccessType()) {
    return (
      <Form layout="inline">
        {initialEnd && renderAddressAttrFormItem()}
      </Form>
    );
  }
  else {
    return '';
  }


};

const mapDispatchToProps = (dispatch, { modelKey }) => ({
  saveData: payload => dispatch({
    type: `${modelKey}/save`,
    payload,
  }),
  qryExchangeListByAddr: async (payload) => {
    return await dispatch({
      type: 'business/qryExchangeListByAddr',
      payload,
    });
  },
  qryStdCodeListByExch: async (payload) => {
    return await dispatch({
      type: 'business/qryStdCodeListByExch',
      payload
    })
  },
});

const Component = connect((state, { modelKey }) => ({
  offerAccessType: state[modelKey].offerAccessType,
  planDetail: state[modelKey].planDetail || {},
  subsDetail: state[modelKey].subsDetail || {},
  exchangeId: state[modelKey].exchangeId || null,
  stdCode: state[modelKey].stdCode || null,
}), mapDispatchToProps)(Form.create()(AddressAttributes));
export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
